import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo7 } from "../../../routes/Module7";
import { modulo8 } from "../../../routes/Module8";
import Imagen1 from "../../../images/modulo7/biblioteca.png";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[7];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo7.content[0].activities[6].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Olga está preocupada por los problemas de su distrito. Ha decidido que
          quiere ser alcaldesa.
        </li>
        <li>Lee las actividades que realiza Olga.</li>
        <li>
          En una hoja, haz un dibujo que grafique alguna de las tres actividades
          que está haciendo Olga.
        </li>
      </ul>

      <div className="row justify-content-center mt-5">
        <div className="col-lg-10 col-12">
          <img src={Imagen1} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-12">
          <Card>
            <div className="p-4 p-lg-0">
              1: Olga lee en la Constitución Política del Perú que tiene{" "}
              <strong>derecho a ser elegida</strong> alcaldesa de su distrito.
              Para ello, debe pertenecer a un partido político.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-12">
          <Card>
            <div className="p-4 p-lg-0">
              2: Olga usa su <strong>derecho a la información</strong> y lee
              muchos documentos para estar preparada para solucionar los
              problemas de su distrito.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-12">
          <Card>
            <div className="p-4 p-lg-0">
              3: Olga usa su <strong>derecho a expresarse</strong>. Hace una
              reunión con los vecinos y les explica sus ideas.
            </div>
          </Card>
        </div>
      </div>
      <ul className="my-3">
        <li>Trabaja con tres compañeros o compañeras.</li>
        <li>
          Entre todos, harán un cartel para convencer a las personas de que
          voten por Olga.
        </li>
      </ul>

      <GuiaDocente>
        <p>
          Lea las indicaciones y las descripciones de lo que hace Olga. Dé un
          tiempo para realizar el dibujo. Concluya la actividad destacando que
          han visto el uso de tres derechos: ser elegido, a la información y a
          la expresión.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo8.url}>
          <button className={`btn btn-${modulo7.color} me-2`}>
            {modulo8.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad8;
